import userService from "../../services/userAPI";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ChangePasswordModal from "./ChangePasswordModal"; // Reusable modal for password change
import { toast } from "react-toastify"; // Updated import
import { toastOptions } from "../../config/toastifyConfig";

function EditUser() {
  const [userData, setUserData] = useState({
    id: 0,
    userName: '',
    firstName: '',
    lastName: '',
    email: ''
  });

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  // Password change fields
  const [oldPassword, setOldPassword] = useState(''); // Old password input for user
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [isProfileEdit, setIsProfileEdit] = useState(false); // Is the user editing their own profile?

  const params = useParams();
  const navigate = useNavigate();

  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      const loggedInUserId = JSON.parse(localStorage.getItem('currentUser'))?.id; // Get logged-in user ID
      const userId = params.userId || loggedInUserId; // If no param, assume editing own profile

      setIsProfileEdit(userId === loggedInUserId); // Determine if it's a profile edit

      if (userId) {
        try {
          const user = await userService.getById(parseInt(userId));
          setUserData(user);
        } catch (error) {
          console.error("Failed to fetch user data:", error);
        }
      }
    };
    fetchUserData();
  }, [params.userId]);

  // Save or update user
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (userData.id === 0) {
        // Creating new user
        if (password !== confirmPassword) {
          toast('Hasła nie są identyczne!', toastOptions);
          return;
        }
        const savedUser = await userService.save(userData);
        await userService.resetPasswordByAdmin(savedUser.id, password); // Set initial password
      } else {
        // Update existing user
        await userService.update(userData);
      }

      navigate("/userList");
    } catch (error) {
      console.error("Failed to save user:", error);
    }
  };

  // Handle password change
  const handlePasswordChange = async (oldPassword, newPassword) => {
    try {
      // Differentiate between admin and user password changes
      if (isProfileEdit) {
        // User changes their own password
        await userService.changePassword(oldPassword, newPassword);
      } else {
        // Admin resets another user's password
        await userService.resetPasswordByAdmin(userData.id, newPassword);
      }
  
      // Show success message
      toast.success("Hasło zostało zmienione pomyślnie!", toastOptions);
      setShowPasswordModal(false); // Close the modal
    } catch (error) {
      console.error("Błąd podczas zmiany hasła:", error.message, toastOptions);
  
      // Handle errors and display meaningful feedback
      const errorMessage = error.response?.data || error.message || "Wystąpił błąd podczas zmiany hasła.";
      toast.error(errorMessage); // Display error in toast
    }
  };

  // Cancel editing
  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group mb-3">
        <label htmlFor="userName">Nazwa użytkownika</label>
        <input
          id="userName"
          type="text"
          value={userData.userName}
          onChange={(e) => setUserData({ ...userData, userName: e.target.value })}
          className="form-control"
          placeholder="Nazwa użytkownika"
          required
        />
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label htmlFor="firstName">Imię</label>
          <input
            id="firstName"
            type="text"
            value={userData.firstName}
            onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
            className="form-control"
            placeholder="Imię"
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="lastName">Nazwisko</label>
          <input
            id="lastName"
            type="text"
            value={userData.lastName}
            onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
            className="form-control"
            placeholder="Nazwisko"
            required
          />
        </div>
      </div>

      <div className="form-group mb-3">
        <label htmlFor="email">e-mail</label>
        <input
          id="email"
          type="email"
          value={userData.email}
          onChange={(e) => setUserData({ ...userData, email: e.target.value })}
          className="form-control"
          placeholder="e-mail"
          required
        />
      </div>

      {/* Password for new users */}
      {userData.id === 0 && (
        <>
          <div className="form-group mb-3">
            <label htmlFor="password">Hasło</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-control"
              required
            />
          </div>
          <div className="form-group mb-3">
            <label htmlFor="confirmPassword">Potwierdź hasło</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="form-control"
              required
            />
          </div>
        </>
      )}

      <div className="d-flex justify-content-end mt-4">
        <button type="submit" className="btn btn-success me-2">Zapisz</button>
        <button type="button" className="btn btn-primary me-2" onClick={() => setShowPasswordModal(true)}>Hasło</button>
        <button type="button" className="btn btn-danger" onClick={handleCancel}>Anuluj</button>
      </div>

      {/* Password Change Modal */}
      <ChangePasswordModal
        show={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        onSubmit={handlePasswordChange}
        isProfileEdit={isProfileEdit} // Pass context
      />
    </form>
  );
}

export default EditUser;
